import type { BFFArticleBodyElement } from "@src/app/types/bff";

import ArticleAnnotation from "./components/ArticleAnnotation";

export default function ArticleParagraph({
  element,
}: {
  element: BFFArticleBodyElement["paragraph"];
}) {
  return (
    <p className="text-primary dark:text-primary-on-dark text-body-1 pb-4">
      <ArticleAnnotation
        value={element.value}
        annotations={element.annotations}
      />
    </p>
  );
}
